<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // this.updateTitle(); // 确保在组件加载后立即更新标题
  },
  watch: {
    // '$route'() {
    //   this.updateTitle(); // 监听路由变化，更新标题
    // }
  },
  methods: {
    // updateTitle() {
    //   const pageTitle = '长安长安'; // 固定部分的标题内容
    //   const routeTitle = this.$route.meta.title || ''; // 当前路由的标题内容
    //   document.title = `${pageTitle}_${routeTitle}`;
    // }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
</style>
